import React from 'react';
import LegalPage from './LegalPage';

const SECTIONS = [
  {
    heading: '1. Information we collect',
    body: 'We collect the information you provide when creating an account and profile (such as email and username), challenge activity, and wallet transaction records needed to operate the platform.',
  },
  {
    heading: '2. Payments',
    body: 'Deposits and withdrawals are processed by Stripe. LockedIn does not store full payment card details; that information is handled by Stripe under their security standards.',
  },
  {
    heading: '3. How we use information',
    body: 'We use your information to provide and improve the service, process wallet activity, settle challenges, prevent abuse, and communicate important account updates.',
  },
  {
    heading: '4. Sharing',
    body: 'We share information with service providers such as Stripe and our infrastructure providers only as needed to operate LockedIn, and as required by law. We do not sell your personal information.',
  },
  {
    heading: '5. Data security',
    body: 'We use industry-standard measures to protect your data. No system is perfectly secure, so we also encourage you to protect your account credentials.',
  },
  {
    heading: '6. Your choices',
    body: 'You can manage your profile and account information inside the app. Contact support for questions about your data or account.',
  },
  {
    heading: '7. Changes',
    body: 'We may update this policy from time to time. Material changes will be reflected here with an updated date.',
  },
];

export default function PrivacyPage() {
  return (
    <LegalPage
      title="Privacy Policy"
      updated="June 2026"
      intro="This policy explains what information LockedIn collects and how we use it. This summary is provided for clarity and does not replace any full legal agreement we may publish."
      sections={SECTIONS}
    />
  );
}
